
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CanonicalService {

  constructor(private router: Router) { }

  updateCanonicalUrl(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentUrl = window.location.href;
        this.setCanonicalUrl(currentUrl);
      }
    });
  }

  private setCanonicalUrl(url: string): void {
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', url);
    } else {
      const newCanonicalLink = document.createElement('link');
      newCanonicalLink.rel = 'canonical';
      newCanonicalLink.href = url;
      document.head.appendChild(newCanonicalLink);
    }
  }
}
